<div class="page main-signin-wrapper">

    <!-- Row -->
    <div class="row signpages justify-content-center">
        <div class="col-md-8 text-center">
            <div class="card">
                <div class="row row-sm">
                    <!-- <div class="col-lg-6 col-xl-5 d-none d-lg-block text-center  bg-primary details">
                        <div class="mt-5 pt-4 p-2   pos-absolute">
                            <div class="clearfix"></div>
                            <img src="../../assets/img/login-2.jpg" class="ht-150 mb-0" alt="user">
                            <h5 class="mt-4 text-white">User Account</h5>
                            <span class="tx-white-6 tx-13 text-center mb-10 mt-xl-0 ">
                                Fill the login form to this Account to gain access
                            </span>
                        </div>
                    </div> -->
                    <div class="col-lg-12 col-xl-12 col-xs-12 col-sm-12 login_form ">
                        <div class="container-fluid">
                            <div class="row row-sm">
                                <div class="card-body mt-2 mb-2">
                                    <div class="clearfix"></div>
                                    <form [formGroup]="loginForm" (ngSubmit)="Submit()" novalidate>
                                        <h5 class="text-center text-xl mb-2">Login</h5>
                                        <p class="mb-4 text-muted text-center tx-13 ml-0 text-left">
                                            Sign In to your account
                                        </p>

                                        <div class="form-group text-left">
                                            <label>Email</label>
                                            <input class="form-control" formControlName="username" type="text">
                                            <div *ngIf="(loginFormControl.username.touched || submitted) && (loginFormControl.username.errors?.required)"
                                                class="tx-danger">

                                            </div>
                                        </div>
                                        <div class="form-group text-left">
                                            <label>Password</label>
                                            <input class="form-control" formControlName="password" type="password">
                                            <div *ngIf="(loginFormControl.password.touched || submitted) && (loginFormControl.password.errors?.required)"
                                                class="tx-danger">
                                                <small>Enter above password</small>
                                            </div>
                                        </div>
                                        <button class="btn ripple btn-main-primary btn-block"
                                            [disabled]="!loginForm.valid">Sign In</button>
                                    </form>
                                    <div class="text-left mt-5 ml-0">
                                        <!-- <div class="mb-1"><a href="javascript:;">Forgot password?</a></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Row -->

</div>

<!-- <img src="../../assets/img/brand/logo-light.png" class="header-brand-img mb-4" alt="logo"> -->
<!-- <img src="../../assets/img/brand/logo.png"
                                        class=" d-lg-none header-brand-img text-left float-left mb-4" alt="logo"> -->
<!--<ngb-alert type="primary" [dismissible]="false">
                                             <span class="alert-inner--text">Use account <strong>spruha@demo.com</strong> and password <strong>spruha</strong> to continue.</span> 
                                        </ngb-alert>-->

<!-- <small>Enter spruha@demo.com to login</small> -->